import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpContextToken,
  HttpContext
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { TokenService } from '../services/token.service'

const CONSENT = new HttpContextToken(() => false)

export function consent() {
  return new HttpContext().set(CONSENT, true)
}

@Injectable()
export class AuthenticationInterceptor implements HttpInterceptor {

  constructor(
    private tokenService: TokenService
  ) { }

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {


    if (request.headers.has('skip')) {

      request = request.clone({
        headers: request.headers.delete('skip')
        //.set('Access-Control-Allow-Origin:', '*')
      })

      return next.handle(request)

    } else if (request.context.get(CONSENT)) {

      const headersConsent = request.clone({
        headers: request.headers
          .set('Authorization', `Bearer ${sessionStorage.getItem('consentToken')}`)
          .set('Content-Type', 'application/json')
          .set('Access-Control-Allow-Credentials', 'true')
        // .set('Access-Control-Allow-Origin', '*')
      })

      // console.log('EnrollmentInterceptor is working')

      return next.handle(headersConsent)

    } else {

      const headers = request.clone({
        headers: request.headers
          .set('Authorization', `Bearer ${this.tokenService.getToken()}`)
          .set('Content-Type', 'application/json')
          .set('Access-Control-Allow-Credentials', 'true')
        // .set('Access-Control-Allow-Origin', '*')
      });

      return next.handle(headers)
    }


  }
}
